<script>
  import { STREAM_IS_LIVE } from '../js/l10n/en_US.js';
  import { playerState, eventState } from '../js/state.js';
  import { secondsToDuration } from '../js/libs/datetime.js';
  import { PLAYER_STATUS_PLAY } from '../js/constants.js';

  export let floating = false;

  let liveClock = '',
    showLiveTimestamp = false,
    liveTickerInterval = null,
    pauseDelay = 0;

  $: if ($eventState.last_active_time !== null && $eventState.last_active_time !== undefined) {
    showLiveTimestamp = true;
    liveTickerInterval =
      liveTickerInterval ||
      setInterval(() => {
        if ($playerState.status != PLAYER_STATUS_PLAY) {
          pauseDelay += 1;
          return;
        }

        const now = new Date().getTime(),
          lastActive = new Date($eventState.last_active_time).getTime(),
          diffSec = (now - lastActive) / 1000 - pauseDelay;

        // 1+ hour?
        if (diffSec >= 60 * 60) {
          liveClock = secondsToDuration(diffSec);
          return;
        }
        liveClock = secondsToDuration(diffSec).substr(3, 5);
      }, 1000);
  } else {
    showLiveTimestamp = false;
    clearInterval(liveTickerInterval);
  }
</script>

<div class="live {floating ? 'floating' : ''}">
  <span class="badge">
    {STREAM_IS_LIVE}
    <i class="icon-videocam" />
  </span>
  {#if showLiveTimestamp}
    <span class="timestamp">{liveClock}</span>
  {/if}
</div>
